import { useState } from "react";
import PropTypes from "prop-types";

import Popover from "@mui/material/Popover";
import TableRow from "@mui/material/TableRow";
import MenuItem from "@mui/material/MenuItem";
import TableCell from "@mui/material/TableCell";
import IconButton from "@mui/material/IconButton";
import Iconify from "../../../components/iconify/iconify";

// ----------------------------------------------------------------------

export default function UserTableRow({
  selected,
  rowNumber,
  applicantName,
  email,
  phone,
  submittedDate,
  onDelete,
  onView,
  onEdit,
  onDownloadPDF,
  handleClick,
}) {
  const [open, setOpen] = useState(null);

  const handleOpenMenu = (event) => setOpen(event.currentTarget);
  const handleCloseMenu = () => setOpen(null);

  return (
    <>
      <TableRow hover tabIndex={-1} selected={selected}>
        <TableCell sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' }, padding: { xs: '8px 4px', sm: '16px' }, width: { md: '5%' }, fontWeight: 500 }}>
          {rowNumber}
        </TableCell>
        <TableCell sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' }, padding: { xs: '8px 4px', sm: '16px' }, width: { md: '22%' } }}>
          {applicantName}
        </TableCell>
        <TableCell sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' }, padding: { xs: '8px 4px', sm: '16px' }, width: { md: '28%' }, wordBreak: 'break-word' }}>
          {email}
        </TableCell>
        <TableCell sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' }, padding: { xs: '8px 4px', sm: '16px' }, width: { md: '18%' } }}>
          {phone}
        </TableCell>
        <TableCell sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' }, padding: { xs: '8px 4px', sm: '16px' }, width: { md: '17%' } }}>
          {submittedDate}
        </TableCell>
        <TableCell align="right" sx={{ padding: { xs: '8px 4px', sm: '16px' }, width: { md: '5%' } }}>
          <IconButton onClick={handleOpenMenu} size={window.innerWidth < 600 ? 'small' : 'medium'}>
            <Iconify icon="eva:more-vertical-fill" />
          </IconButton>
        </TableCell>
      </TableRow>

      <Popover
        open={!!open}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{ sx: { width: 160 } }}
      >
        <MenuItem onClick={() => { onView(); handleCloseMenu(); }}>
          <Iconify icon="eva:eye-fill" sx={{ mr: 2 }} />
          View Details
        </MenuItem>

        <MenuItem onClick={() => { onEdit(); handleCloseMenu(); }}>
          <Iconify icon="eva:edit-fill" sx={{ mr: 2 }} />
          Edit
        </MenuItem>

        <MenuItem onClick={() => { onDownloadPDF(); handleCloseMenu(); }}>
          <Iconify icon="eva:download-fill" sx={{ mr: 2 }} />
          Download PDF
        </MenuItem>

        <MenuItem onClick={() => { onDelete(); handleCloseMenu(); }} sx={{ color: 'error.main' }}>
          <Iconify icon="eva:trash-2-outline" sx={{ mr: 2 }} />
          Delete
        </MenuItem>
      </Popover>
    </>
  );
}

UserTableRow.propTypes = {
  selected: PropTypes.bool,
  rowNumber: PropTypes.number,
  applicantName: PropTypes.string,
  email: PropTypes.string,
  phone: PropTypes.string,
  submittedDate: PropTypes.string,
  onDelete: PropTypes.func,
  onView: PropTypes.func,
  onEdit: PropTypes.func,
  onDownloadPDF: PropTypes.func,
  handleClick: PropTypes.func,
};